<template>

  <v-container class="pt-16">

    <v-row justify="center">
      <v-col
        xs="12"
        sm="8"
        md="8"
        lg="6"
        xl="4"
        xxl="3"
      >

        <!-- TODO: reduce size -->
        <img
          src="../assets/images/logo-icon-purple.png"
          alt="Ocra logo"
          class="d-block mx-auto mb-12"
          style="max-width: 48px;"
        />

        <h1 class="text-center mb-12">
          {{ title }}
        </h1>

        <slot></slot>

      </v-col>
    </v-row>

  </v-container>

</template>

<script setup lang="ts">

interface Props {
  title: string
}

defineProps<Props>()

</script>
